<template>
  <div class="uk-flex uk-flex-column main-block" v-if="isLogined">
   <div class="news-block uk-flex uk-flex-column">
       <div>
           Новини
       </div>
       <div>Головна сторінка: <router-link to="/admin/news">Новини</router-link></div>
       <div>Додати новину: <router-link to="/admin/addnews">Додати новину</router-link></div>
   </div>
   <div class="tariff-block uk-flex uk-flex-column">
       <div>
           Тарифи
       </div>
       <div>Зміна тарифів: <router-link to="/admin/tariff">Змінити тарифи</router-link></div>
   </div>
    <button @click=logout>Вийти з аккаунту</button>
</div>

  
</template>

<script>
  import {loginFromSession} from "@/login.js"
  
  export default {
    name: "AdminMenu",

    data: function () {
      return {
        
      }
    },

    methods: {
      logout(){
          this.$store.dispatch('logout')
          this.$router.push('/')
      },
    },

    computed: {
      isLogined()
      {
        return loginFromSession()
      },
    },
  }
</script>

<style scoped>
.main-block{
  align-items: center;
}

.news-block, .admin-block, .tariff-block{
  width: 40%;
  align-items: center;
  margin-top: 20px;
}
</style>